import request from "@/config/_request";
// import qs from "qs";
//查询分校列表
export function getSchoolList(params) {
  return request({
    url: "/java-api/school/edu/campus/queryListByUserId",
    params,
    method: "get",
  });
}

// 线索数据
export function boardsoa(params) {
  return request({
    url: "/java-api/school/intend/board/soa",
    data: params,
    headers: {
      "Content-Type": "application/json"
    },
    method: "post",
  });
}

//学员数据
export function stuRecSoa(params) {
  return request({
    url: "/java-api/school/stu/board/recSoa",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//老师上课记录
export function tchrecordSoa(params) {
  return request({
    url: "/java-api/school/tch/board/recordSoa",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//收益情况
export function boardIncomeSoa(params) {
  return request({
    url: "/java-api/school/stu/board/incomeSoa",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-线索数据
export function boardEchartsStat(params) {
  return request({
    url: "/java-api/school/intend/board/echarts/stat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

//Echarts-线索数据
export function boardEchartsRecStat(params) {
  return request({
    url: "/java-api/school/stu/board/echarts/recStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-老师上课统计
export function tchEchartsRecordStat(params) {
  return request({
    url: "/java-api/school/tch/board/echarts/recordStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-学生课消统计
export function boardEchartsConsumeStat(params) {
  return request({
    url: "/java-api/school/stu/board/echarts/consumeStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-老师到课率统计
export function boardEchartsAttnStat(params) {
  return request({
    url: "/java-api/school/tch/board/echarts/attnStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-校区到课率统计
export function campusEchartsAttnStat(params) {
  return request({
    url: "/java-api/school/edu/campus/echarts/attnStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//Echarts-分校消耗天数统计
export function eduCampusConsumeDayStat(params) {
  return request({
    url: "/java-api/school/edu/campus/consumeDayStat",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
//课堂点评
export function classCmtQuery(params) {
  return request({
    url: "/java-api/school/tch/board/classCmtQuery",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/******************************星币管理**********************************************星币管理 **********************************************星币管理*******************************/
/******************************************************************超管端 ******************************************************************/
/**
 * 规则设置 - 展示
 * @param {*} params 
 * @returns 
 */
export function adminTmplRuleTagShow(params) {
  return request({
    url: "/java-api/points/admin/tmplRuleTag/show",
    params,
    method: "get",
    admin: true
  });
}

/**
 * 规则设置 - 编辑
 * @param {*} params 
 * @returns 
 */
export function adminTmplRuleTagEdit(params) {
  return request({
    url: "/java-api/points/admin/tmplRuleTag/edit",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    admin: true
  });
}

/**
 * 模板商品 列表查询
 * @param {*} params 
 * @returns 
 */
export function adminTmplProductQueryList(params) {
  return request({
    url: "/java-api/points/admin/tmplProduct/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    admin: true
  });
}
/**
 * 模板商品 创建
 * @param {*} params 
 * @returns 
 */
export function adminTmplProductCreate(params) {
  return request({
    url: "/java-api/points/admin/tmplProduct/create",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    admin: true
  });
}
/**
 * 模板商品 编辑
 * @param {*} params 
 * @returns 
 */
export function adminTmplProductEdit(params) {
  return request({
    url: "/java-api/points/admin/tmplProduct/edit",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    admin: true
  });
}
/**
 * 模板商品 上/下架
 * @param {*} params 
 * @returns 
 */
export function adminTmplProductUpdateState(params) {
  return request({
    url: "/java-api/points/admin/tmplProduct/updateState",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    admin: true
  });
}

/****************************************************************** 前台部分 ******************************************************************/
/**学校端 */
/**
 * 积分模块 星币管理权限
 * @param {*} params 
 * @returns 
 */
export function api_updateSchoolPointAuth(params) {
  return request({
    url: "/java-api/school/edu/updatePointsAuth",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 规则设置 - 查看
 * @param {*} params 
 * @returns 
 */
export function api_schoolEduCampusCheck(params) {
  return request({
    url: "/java-api/points/sch/eduCampus/check",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 规则设置 - 编辑
 * @param {*} params 
 * @returns 
 */
export function api_schoolEduCampusTagEdit(params) {
  return request({
    url: "/java-api/points/sch/eduCampus/edit",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 规则设置 - 隐藏、显示标签
 * @param {*} params 
 * @returns 
 */
export function api_schoolRuleTagHide(params) {
  return request({
    url: "/java-api/points/sch/ruleTag/hide",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 规则设置 - 星币发放规则
 * @param {*} params 
 * @returns 
 */
export function api_schoolEduCampusStarRule(params) {
  return request({
    url: "/java-api/points/sch/eduCampus/starRule",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 星币明细 奖励列表
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantQueryList(params) {
  return request({
    url: "/java-api/points/sch/starGrant/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 订单管理 列表 / 星币明细 消耗列表     -----混合接口
 * @param {*} params 
 * @returns 
 */
export function api_schoolOrderQueryList(params) {
  return request({
    url: "/java-api/points/sch/order/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 订单管理 查看详情
 * @param {*} params 
 * @returns 
 */
export function api_schoolOrderCheckDetial(params) {
  return request({
    url: "/java-api/points/sch/order/checkDetail",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 订单管理 审批 / 星币明细 审批     -----混合接口
 * @param {*} params 
 * @returns 
 */
export function api_schoolOrderApproval(params) {
  return request({
    url: "/java-api/points/sch/order/approval",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 商品管理 列表
 * @param {*} params 
 * @returns 
 */
export function api_schoolProductQueryList(params) {
  return request({
    url: "/java-api/points/sch/product/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 商品管理 新增
 * @param {*} params 
 * @returns 
 */
export function api_schoolProductCreate(params) {
  return request({
    url: "/java-api/points/sch/product/create",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 商品管理 编辑/下架/删除
 * @param {*} params 
 * @returns 
 */
export function api_schoolProductEdit(params) {
  return request({
    url: "/java-api/points/sch/product/edit",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 星币排行 查询
 * @param {*} params 
 * @returns 
 */
export function api_schoolStuStarQueryList(params) {
  return request({
    url: "/java-api/points/sch/stuStar/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 公共接口-发放/扣除星币
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantGrant(params) {
  return request({
    url: "/java-api/points/sch/starGrant/grant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 阅卷评分后 - 星币发放-考试发放
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantExamGrant(params) {
  return request({
    url: "/java-api/points/sch/starGrant/examGrant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币发放-查看-考试/课堂点评
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantCheck(params) {
  return request({
    url: "/java-api/points/sch/starGrant/check",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币发放-删除-考试/课堂点评
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantDelete(params) {
  return request({
    url: "/java-api/points/sch/starGrant/delete",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币发放-课堂点评发放
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantLectureWorkGrant(params) {
  return request({
    url: "/java-api/points/sch/starGrant/lectureWorkGrant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币发放-出勤缺勤
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantSignGrant(params) {
  return request({
    url: "/java-api/points/sch/starGrant/signGrant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币排行 星币获取记录
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantGetStarRecord(params) {
  return request({
    url: "/java-api/points/sch/starGrant/getStarRecord",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币排行 自由发放
 * @param {*} params 
 * @returns 
 */
export function api_schoolStarGrantActiveGrant(params) {
  return request({
    url: "/java-api/points/sch/starGrant/activeGrant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/***学生端 */
/**
 * 学生获取自己的头衔信息
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderWearState(params) {
  return request({
    url: "/java-api/points/stu/order/wearState",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 学生更新头像状态
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderUpdateHeadState(params) {
  return request({
    url: "/java-api/points/stu/order/updateHeadState",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**
 * 星币中心 学生星币情况
 * @param {*} params 
 * @returns 
 */
export function api_stuStuStarPersonalSoa(params) {
  return request({
    url: "/java-api/points/stu/stuStar/personalSoa",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心 商品兑换列表
 * @param {*} params 
 * @returns 
 */
export function api_stuProductRedeemList(params) {
  return request({
    url: "/java-api/points/stu/product/redeemList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心 兑换记录
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderStuRedeemRecord(params) {
  return request({
    url: "/java-api/points/stu/order/stuRedeemRecord",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心 星币明细(获取记录)
 * @param {*} params 
 * @returns 
 */
export function api_stuStarGrantQueryList(params) {
  return request({
    url: "/java-api/points/stu/starGrant/queryList",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心 兑换商品
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderExchange(params) {
  return request({
    url: "/java-api/points/stu/order/exchange",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心  我的商品列表
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderSelectListByStu(params) {
  return request({
    url: "/java-api/points/stu/order/selectListByStu",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 星币中心  更改佩戴状态
 * @param {*} params 
 * @returns 
 */
export function api_stuOrderUpdateWearState(params) {
  return request({
    url: "/java-api/points/stu/order/updateWearState",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 班级详情-星币排行
 * @param {*} params 
 * @returns 
 */
export function api_stuStuStarClassStarRank(params) {
  return request({
    url: "/java-api/points/stu/stuStar/classStarRank",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 学生星币管理-星币排行 班级榜
 * @param {*} params 
 * @returns 
 */
export function api_stuStuStarStuClassStarRank(params) {
  return request({
    url: "/java-api/points/stu/stuStar/stuClassStarRank",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 学生星币管理-星币排行 总排行
 * @param {*} params 
 * @returns 
 */
export function api_stuStuStarEduCampusStarRank(params) {
  return request({
    url: "/java-api/points/stu/stuStar/eduCampusStarRank",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 学生端 - 星币发放规则
 * @param {*} params 
 * @returns 
 */
export function api_stuEduCampusStarRule(params) {
  return request({
    url: "/java-api/points/stu/eduCampus/starRule",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/**教师端 */

/**
 * 我的教室 规则查看
 * @param {*} params 
 * @returns 
 */
export function api_tchRuleTagCheck(params) {
  return request({
    url: "/java-api/points/tch/ruleTag/check",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}
/**
 * 我的教室 星币排行榜
 * @param {*} params 
 * @returns 
 */
export function api_tchStuStarRanking(params) {
  return request({
    url: "/java-api/points/tch/stuStar/ranking",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    noLoading: true
  });
}
/**
 * 我的教室 教师发放星币
 * @param {*} params 
 * @returns 
 */
export function api_tchStarGrantClassRoomGrant(params) {
  return request({
    url: "/java-api/points/tch/starGrant/classRoomGrant",
    data: params,
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
  });
}

/******************************2.1.8权限管理****************************************2.1.8权限管理 ******************************************2.1.8权限管理*******************************/

// const getRestArgs = ()=>({
//   params,
//   method: "get",
//   admin: true
// })
const postRestArgs = (params, admin = true) => ({
  data: params,
  method: "post",
  headers: {
    "Content-Type": "application/json"
  },
  admin,
})
/**
 * admin 导航设置
 * @param {*} params 
 * @returns 
 */
export function api_queryResourceTree(params) {
  return request({
    url: "/java-api/auth/admin/resource/queryResourceTree",
    ...postRestArgs(params)
  });
}
export function api_createResourceTree(params) {
  return request({
    url: "/java-api/auth/admin/resource/create",
    ...postRestArgs(params)
  });
}
export function api_editResourceTree(params) {
  return request({
    url: "/java-api/auth/admin/resource/edit",
    ...postRestArgs(params)
  });
}
export function api_deleteResourceTree(params) {
  return request({
    url: "/java-api/auth/admin/resource/delete",
    ...postRestArgs(params)
  });
}

/**
 * admin 角色设置 - 查询列表
 * @param {*} params 
 * @returns 
 */
export function api_roleTypeQueryList(params) {
  return request({
    url: "/java-api/auth/admin/roleType/queryList",
    ...postRestArgs(params)
  });
}
/**
 * admin 角色设置 - 创建角色
 * @param {*} params 
 * @returns 
 */
export function api_roleTypeCreate(params) {
  return request({
    url: "/java-api/auth/admin/roleType/create",
    ...postRestArgs(params)
  });
}
/**
 * admin 角色设置 - 修改角色
 * @param {*} params 
 * @returns 
 */
export function api_roleTypeEdit(params) {
  return request({
    url: "/java-api/auth/admin/roleType/edit",
    ...postRestArgs(params)
  });
}
/**
 * admin 角色设置 - 删除角色
 * @param {*} params 
 * @returns 
 */
export function api_roleTypeDelete(params) {
  return request({
    url: "/java-api/auth/admin/roleType/delete",
    ...postRestArgs(params)
  });
}
/**
 * admin 角色设置 - 查看角色详情
 * @param {*} params 
 * @returns 
 */
export function api_roleTypeViewDetail(params) {
  return request({
    url: "/java-api/auth/admin/roleType/viewDetail",
    ...postRestArgs(params)
  });
}

/**
 * admin 套餐管理 - 列表查询
 * @param {*} params 
 * @returns 
 */
export function api_mealQueryList(params) {
  return request({
    url: "/java-api/auth/admin/meal/queryList",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 新增套餐
 * @param {*} params 
 * @returns 
 */
export function api_mealCreate(params) {
  return request({
    url: "/java-api/auth/admin/meal/create",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 修改套餐
 * @param {*} params 
 * @returns 
 */
export function api_mealEdit(params) {
  return request({
    url: "/java-api/auth/admin/meal/edit",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 删除套餐
 * @param {*} params 
 * @returns 
 */
export function api_mealDelete(params) {
  return request({
    url: "/java-api/auth/admin/meal/delete",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 查看套餐详情
 * @param {*} params 
 * @returns 
 */
export function api_mealViewDetail(params) {
  return request({
    url: "/java-api/auth/admin/meal/viewDetail",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 更改套餐有效状态
 * @param {*} params 
 * @returns 
 */
export function api_mealUpdateValid(params) {
  return request({
    url: "/java-api/auth/admin/meal/updateValid",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 公共接口-有效套餐列表
 * @param {*} params 
 * @returns 
 */
export function api_mealQueryValidList(params) {
  return request({
    url: "/java-api/auth/admin/meal/queryValidList",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 公共接口-查看当前机构使用套餐
 * @param {*} params 
 * @returns 
 */
export function api_eduMealViewDetail(params) {
  return request({
    url: "/java-api/auth/admin/eduMeal/viewDetail",
    ...postRestArgs(params)
  });
}
/**
 * admin 套餐管理 - 公共接口-机构修改套餐
 * @param {*} params 
 * @returns 
 */
export function api_eduMealEdit(params) {
  return request({
    url: "/java-api/auth/admin/eduMeal/edit",
    ...postRestArgs(params)
  });
}
/**
 * admin 学校管理-教师管理-查询教师列表
 * @param {*} params 
 * @returns 
 */
export function api_userTchManageTchRoleUserList(params) {
  return request({
    url: "/java-api/admin/user/tchManage/tchRoleUserList",
    ...postRestArgs(params)
  });
}
/**
 * admin 学校管理 - 教师管理 - 删除用户教师身份
 * @param {*} params 
 * @returns 
 */
export function api_tchManageDeleteUserTchRole(params) {
  return request({
    url: "/java-api/auth/admin/tchManage/deleteUserTchRole",
    ...postRestArgs(params)
  });
}

/************************************************ 校区管理 ************************************************ */

/**
 * 权限设置 查看权限树
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleQueryResourceTree(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/queryResourceTree",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查询角色列表
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleQueryList(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/queryList",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查询角色列表及教师状态
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleGetTchRoleMap(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/getTchRoleMap",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查看角色类型列表
 * @param {*} params 
 * @returns 
 */
export function api_schRoleTypeQueryList(params) {
  return request({
    url: "/java-api/auth/sch/roleType/queryList",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 新增角色
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleCreate(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/create",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 编辑角色
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleEdit(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/edit",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 删除角色
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleDelete(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/delete",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查看角色权限详情
 * @param {*} params 
 * @returns 
 */
export function api_schEduRoleViewDetail(params) {
  return request({
    url: "/java-api/auth/sch/eduRole/viewDetail",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查看模板角色权限详情
 * @param {*} params 
 * @returns 
 */
export function api_schRoleTypeViewDetail(params) {
  return request({
    url: "/java-api/auth/sch/roleType/viewDetail",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 员工设置-查询员工列表
 * @param {*} params 
 * @returns 
 */
export function api_tchEmployeeSettingSelectEmployList(params) {
  return request({
    url: "/java-api/school/tch/employeeSetting/selectEmployList",
    ...postRestArgs(params, false)
  });
}
/**
 * 权限设置 员工设置-用户详情
 * @param {*} params 
 * @returns 
 */
export function api_tchEmployeeSettingViewDetail(params) {
  return request({
    url: "/java-api/school/tch/employeeSetting/viewDetail",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 员工设置-创建用户
 * @param {*} params 
 * @returns 
 */
export function api_tchEmployeeSettingCreate(params) {
  return request({
    url: "/java-api/school/tch/employeeSetting/create",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 员工设置-修改用户
 * @param {*} params 
 * @returns 
 */
export function api_tchEmployeeSettingUpdate(params) {
  return request({
    url: "/java-api/school/tch/employeeSetting/update",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 员工设置-重置密码
 * @param {*} params 
 * @returns 
 */
export function api_tchEmployeeSettingResetPassword(params) {
  return request({
    url: "/java-api/school/tch/employeeSetting/resetPassword",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 老师检查密码强度
 * @param {*} params 
 * @returns 
 */
export function api_tchCheckPwd(params) {
  return request({
    url: "/java-api/school/tch/checkPwd",
    ...postRestArgs(params, false),
    noLoading: true
  });
}
/**
 * 权限设置 学生检查密码强度
 * @param {*} params 
 * @returns 
 */
export function api_stuCheckPwd(params) {
  return request({
    url: "/java-api/student/stu/checkPwd",
    ...postRestArgs(params, false),
    noLoading: true
  });
}

/**
 * 权限设置 个人栏-修改密码
 * @param {*} params 
 * @returns 
 */
export function api_tchPersonalColumnUpdatePassword(params) {
  return request({
    url: "/java-api/school/tch/personalColumn/updatePassword",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 系统设置-基础设置-查询分校列表
 * @param {*} params 
 * @returns 
 */
export function api_eduCampusSelectEduCampusTchList(params) {
  return request({
    url: "/java-api/school/edu/campus/selectEduCampusTchList",
    ...postRestArgs(params, false)
  });
}

/**
 * 权限设置 查询校区教师列表
 * @param {*} params 
 * @returns 
 */
export function api_eduCampusSelectTchListByCampus(params) {
  return request({
    url: "/java-api/school/tch/selectTchListByCampus",
    ...postRestArgs(params, false)
  });
}
/**
 * 权限设置 查询教师列表-根据机构
 * @param {*} params 
 * @returns 
 */
export function api_tchSelectTchListByEdu(params) {
  return request({
    url: "/java-api/school/tch/selectTchListByEdu",
    ...postRestArgs(params, false)
  });
}

/*
 * 校区管理-学员管理-编辑学员信息
 * @param {*} params 
 * @returns 
 */
export function api_stuEdit(params) {
  return request({
    url: "/java-api/school/stu/edit",
    ...postRestArgs(params, false)
  });
}



/**
 * 平台权益-使用明细-查询
 * @param {*} params 
 * @returns 
 */
export function api_stuTimeRecordSelectDetail(params) {
  return request({
    url: "/java-api/school/stuTimeRecord/selectDetail",
    ...postRestArgs(params, false)
  });
}
/**
 * 平台权益-操作人列表查询
 * @param {*} params 
 * @returns 
 */
export function api_tchSelectByEduId(params) {
  return request({
    url: "/java-api/school/tch/selectByEduId",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-学员管理-列表查询
 * @param {*} params 
 * @returns 
 */
export function api_stuSelectStudy(params) {
  return request({
    url: "/java-api/school/stu/selectStudy",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-学员管理-报读课程查询
 * @param {*} params 
 * @returns 
 */
export function api_stuSelectSignCourse(params) {
  return request({
    url: "/java-api/school/stu/selectSignCourse",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-上课记录-点名记录查询
 * @param {*} params 
 * @returns 
 */
export function api_tchPlanSelectSignRecord(params) {
  return request({
    url: "/java-api/school/tchPlan/selectSignRecord",
    ...postRestArgs(params, false)
  });
}
/**
 * 财务中心-课消记录-查询
 * @param {*} params 
 * @returns 
 */
export function api_lessonHourRecordSelectLessonCost(params) {
  return request({
    url: "/java-api/school/lessonHourRecord/selectLessonCost",
    ...postRestArgs(params, false)
  });
}
/**
 * 财务中心-收支明细-查询
 * @param {*} params 
 * @returns 
 */
export function api_orderPayRecordSelectOrderPayDetail(params) {
  return request({
    url: "/java-api/school/orderPayRecord/selectOrderPayDetail",
    ...postRestArgs(params, false)
  });
}
/**
 * 财务中心-订单管理-订单明细查询
 * @param {*} params 
 * @returns 
 */
export function api_orderGoodsSelectOrderDetail(params) {
  return request({
    url: "/java-api/school/orderGoods/selectOrderDetail",
    ...postRestArgs(params, false)
  });
}

/**
 * 系统设置-个性化设置-获取学生端密码强度提示
 * @param {*} params 
 * @returns 
 */
export function api_eduTchGetStuPwdRemind(params) {
  return request({
    url: "/java-api/school/edu/getStuPwdRemind",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-修改学生端密码强度提示
 * @param {*} params 
 * @returns 
 */
export function api_eduUpdateStuPwdRemind(params) {
  return request({
    url: "/java-api/school/edu/updateStuPwdRemind",
    ...postRestArgs(params, false)
  });
}

/**
 * 获取学生端密码强度提示
 * @param {*} params 
 * @returns 
 */
export function api_stuGetStuPwdRemind(params) {
  return request({
    url: "/java-api/student/stu/getStuPwdRemind",
    ...postRestArgs(params, false),
    noLoading: true
  });
}

/********************************************************************* v2.3.5.2 */
/**
 * 系统设置-个性化设置-学习报告设置详情
 */
export function api_eduCampusShareReportDetail(params) {
  return request({
    url: "/java-api/school/eduCampusShareReport/detail",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-学习报告设置详情
 */
export function api_eduCampusShareReportEdit(params) {
  return request({
    url: "/java-api/school/eduCampusShareReport/edit",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-查询
 */
export function api_intendSelectList(params) {
  return request({
    url: "/java-api/school/intend/selectList",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-修改线索状态
 */
export function api_intendUpdateState(params) {
  return request({
    url: "/java-api/school/intend/updateState",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-批量分配线索
 */
export function api_intendAssignClue(params) {
  return request({
    url: "/java-api/school/intend/assignClue",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-跟进记录
 */
export function api_intendSelectIntendRecord(params) {
  return request({
    url: "/java-api/school/intend/selectIntendRecord",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-编辑详情
 */
export function api_intendSelectEditDetail(params) {
  return request({
    url: "/java-api/school/intend/selectEditDetail",
    ...postRestArgs(params, false)
  });
}
/**
 * 通用-查询该校区下所有人员
 */
export function api_tchCommonSelectByEduCampusId(params) {
  return request({
    url: "/java-api/school/tch/common/selectByEduCampusId",
    ...postRestArgs(params, false)
  });
}
/**
 * 获取评论赞数信息
 */
export function api_stuTchPlanEvaGetEvaZanList(params) {
  return request({
    url: "/java-api/school/stuTchPlanEva/getEvaZanList",
    ...postRestArgs(params, false)
  });
}
/**
 * 修改评论分享学习报告星币发放类型
 */
export function api_stuTchPlanEvaUpdateShareReportType(params) {
  return request({
    url: "/java-api/school/stuTchPlanEva/updateShareReportType",
    ...postRestArgs(params, false)
  });
}

/*************************************************************************** 2.4.1 ****************************************************************** */

/**
 * 线索管理-线索池-新增线索
 */
export function api_intendSave(params) {
  return request({
    url: "/java-api/school/intend/save",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-批量删除
 */
export function api_intendDelete(params) {
  return request({
    url: "/java-api/school/intend/delete",
    ...postRestArgs(params, false)
  });
}
/**
 * 线索管理-线索池-批量新增线索
 */
export function api_intendSaveBatch(params) {
  return request({
    url: "/java-api/school/intend/saveBatch",
    ...postRestArgs(params, false)
  });
}
/**
 * 我的班级-学员信息
 */
export function api_stuSelectStuClsMsg(params) {
  return request({
    url: "/java-api/school/stu/selectStuClsMsg",
    ...postRestArgs(params, false)
  });
}
/**
 * 我的班级-学员信息-平台权限
 */
export function api_stuUpdateAuth(params) {
  return request({
    url: "/java-api/school/stu/updateAuth",
    ...postRestArgs(params, false)
  });
}
/**
 * 商品管理-实物商品删除校验
 */
export function api_schProductCheckExchange(params) {
  return request({
    url: "/java-api/points/sch/product/checkExchange",
    ...postRestArgs(params, false)
  });
}

/**
 * admin 角色设置 - 查看角色详情
 * @param {*} params 
 * @returns 
 */
export function api_userSelectChangeRecord(params) {
  return request({
    url: "/java-api/admin/user/selectChangeRecord",
    ...postRestArgs(params)
  });
}

/**
 * 系统设置-个性化设置-点名个则设置-查询设置信息
 */
export function api_eduGetSchoolClassSignStateResult(params) {
  return request({
    url: "/java-api/school/edu/getSchoolClassSignStateResult",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-点名个则设置-更新记录课时班级缺勤扣除课时设置 
 */
export function api_eduUpdateXmClassMissSign(params) {
  return request({
    url: "/java-api/school/edu/updateXmClassMissSign",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-点名个则设置-更新不记录课时班级签到扣除课时设置
 */
export function api_eduUpdateNoXmClassSign(params) {
  return request({
    url: "/java-api/school/edu/updateNoXmClassSign",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-点名个则设置-更新不记录课时班级缺勤扣除课时设置
 */
export function api_eduUpdateNoXmClassMissSign(params) {
  return request({
    url: "/java-api/school/edu/updateNoXmClassMissSign",
    ...postRestArgs(params, false)
  });
}

/*************************************************************************** 2.4.2 ****************************************************************** */

/**
 * 系统设置-个性化设置-学生端家校通-更新公众号二维码示设置
 */
export function api_eduUpdateWechatQr(params) {
  return request({
    url: "/java-api/school/edu/updateWechatQr",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-个性化设置-学生端家校通-更新小程序二维码显示设置
 */
export function api_eduUpdateWechatMiniQr(params) {
  return request({
    url: "/java-api/school/edu/updateWechatMiniQr",
    ...postRestArgs(params, false)
  });
}
/**
 * 数据看板-访问记录列表
 */
export function api_visitRecordSelectList(params) {
  return request({
    url: "/java-api/school/visitRecord/selectList",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-学员管理-删除学员
 */
export function api_stuDelete(params) {
  return request({
    url: "/java-api/school/stu/delete",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-班级管理-删除班级
 */
export function api_currClsDelete(params) {
  return request({
    url: "/java-api/school/currCls/delete",
    ...postRestArgs(params, false)
  });
}
/**
 * 操作日志-列表查询
 */
export function api_userOperateSelectList(params) {
  return request({
    url: "/java-api/school/userOperate/selectList",
    ...postRestArgs(params, false)
  });
}
/**
 * 判题机-发放星币
 */
export function api_stuStarGrantGrantOjProblem(params) {
  return request({
    url: "/java-api/points/stu/starGrant/grantOjProblem",
    ...postRestArgs(params, false)
  });
}
/**
 * 系统设置-社区设置-作品社区权限
 */
export function api_eduUpdateStuZoneAuth(params) {
  return request({
    url: "/java-api/school/edu/updateStuZoneAuth",
    ...postRestArgs(params, false)
  });
}
/**
 * 教务中心-学员管理-设置有效期
 */
export function api_stuSetEndDate(params) {
  return request({
    url: "/java-api/school/stu/setEndDate",
    ...postRestArgs(params, false)
  });
}
